import { FaBolt, FaShoePrints, FaSprayCan } from 'react-icons/fa6';

import { LandingHero } from 'constants/landing-hero';

import { BRAND_COLLABS, BRAND_TESTIMONIAL } from '../constants';
import * as styled from '../styles/brand-collabs';
import { PillTag } from './pill-tag';
import { SectionHeading } from './section-heading';

const AVATAR_BACKGROUND: Record<LandingV2.BrandCollab['avatarBg'], string> = {
  ink: LandingHero.collabAvatar.ink,
  accent: LandingHero.collabAvatar.sky,
  pink: LandingHero.collabAvatar.pink,
};

// Generic, non-brand icons standing in for a real company logo — never a
// real trademarked mark, since these are fictional collab partners.
const AVATAR_ICON: Record<LandingV2.BrandCollabIcon, React.ReactNode> = {
  energy: <FaBolt size={20} color={LandingHero.logoText} />,
  sneaker: <FaShoePrints size={20} color={LandingHero.logoText} />,
  cosmetics: <FaSprayCan size={20} color={LandingHero.logoText} />,
};

export const BrandCollabs = () => {
  return (
    <styled.Wrap>
      <SectionHeading
        title="Brands you've worked with, on the page."
        subtitle="The first thing a brand wants to know is who trusted you already. Not a screenshot you dig up when they ask."
        align="center"
      />
      <styled.Grid>
        {BRAND_COLLABS.map((collab) => (
          <styled.Card key={collab.name}>
            <styled.TopRow>
              <styled.Avatar $background={AVATAR_BACKGROUND[collab.avatarBg]}>
                {AVATAR_ICON[collab.icon]}
              </styled.Avatar>
              <styled.Meta>
                <styled.Name>{collab.name}</styled.Name>
                <styled.Date>{collab.date}</styled.Date>
              </styled.Meta>
            </styled.TopRow>
            <styled.Description>{collab.description}</styled.Description>
            <styled.TagRow>
              {collab.tags.map((tag, index) => (
                <PillTag key={tag} label={tag} tone={index === 0 ? 'success' : 'neutral'} />
              ))}
            </styled.TagRow>
          </styled.Card>
        ))}
      </styled.Grid>
      <styled.Testimonial>
        <styled.Quote>&ldquo;{BRAND_TESTIMONIAL.quote}&rdquo;</styled.Quote>
        <styled.Attribution>{BRAND_TESTIMONIAL.attribution}</styled.Attribution>
      </styled.Testimonial>
    </styled.Wrap>
  );
};
